import { FeatureFlag } from 'app/api/services/site-configs/types';

import { isSSR } from 'app/packages/components';

export const getFeatureFlagFromWindow = (featureFlag: FeatureFlag): boolean => {
  if (isSSR) {
    console.error('Function can\'t be executed on server side');

    return false;
  }

  const isFeatureFlagEnabled = window.__fss?.flags?.[featureFlag]?.enabled;

  if (typeof isFeatureFlagEnabled !== 'undefined') {
    return isFeatureFlagEnabled;
  }

  console.error(`window.__fss.flags.[featureFlag].enabled = ${isFeatureFlagEnabled}, if feature flag = ${featureFlag}`);

  return false;
};
